
import {
    ChakraProvider,
    Button,
    Flex,
    Heading,
    Modal,
    ModalBody,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    chakra,
    Container,
    Stack,
    Text,
    Box,
    Image,
    VStack,
    SimpleGrid,
    StackDivider,
    useColorModeValue,
    VisuallyHidden,
    List,
    ListItem,
    Table,
    Thead,
    Tbody,
    Tfoot,
    Tr,
    Th,
    Td,
    TableCaption,
    Center,
    Spinner,
    ModalCloseButton,
    Badge,
} from '@chakra-ui/react';
import React, { useEffect, useState } from "react";
import { render } from "react-dom";
import Moment from 'react-moment';
import { useGetProductByIdMutation } from "../../store/api";

export type ModalProps<Data extends object> = {
    onClose: any,
    id: number,
};
export default function ProductModal({
    onClose,
    id
}: ModalProps<any>) {
    const [getProductById, { data, isLoading, error, isError, isSuccess }] =
        useGetProductByIdMutation();

    const retrieveProduct = () => {
        getProductById(id).unwrap().then(res => {
            console.log('res: ', res);
        }, error => {
            console.log('error: ', error);
        })
    };

    useEffect(retrieveProduct, [id]);
    return (
        <Modal
            onClose={onClose}
            isOpen={true}
            size={"xl"}
            scrollBehavior={"inside"}

        >
            <ModalOverlay>
                <ModalContent>
                    <ModalHeader>
                        <Text
                            fontSize={{ base: '16px', lg: '18px' }}
                            color='yellow.500'
                            fontWeight={'500'}
                            textTransform={'uppercase'}
                            mb={'4'}
                            align={'center'}>
                            Product Details
                        </Text>
                        {isLoading &&
                            <Text
                                fontSize={{ base: '16px', lg: '18px' }}
                                color='yellow.500'
                                fontWeight={'500'}
                                textTransform={'uppercase'}
                                mb={'4'}
                                align={'center'}
                                py={10} px={15}>
                                <Spinner
                                    direction='row' spacing={4}
                                    thickness='4px'
                                    speed='0.5s'
                                    emptyColor='yellow.200'
                                    color='blue.500'
                                    size='xl'
                                    label='Loading...'
                                />
                            </Text>
                        }
                    </ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Flex>
                            <Container >
                                <SimpleGrid>
                                    <Stack
                                        spacing={{ base: 4, sm: 6 }}
                                        direction={'row'}>
                                        {!isLoading &&
                                            <Box>
                                                <List spacing={1}>
                                                    <ListItem>
                                                        <Text as={'span'} fontWeight={'bold'}>
                                                            Name:
                                                        </Text>{' '}
                                                        {data?.name}
                                                    </ListItem>
                                                    <ListItem>
                                                        <Text as={'span'} fontWeight={'bold'}>
                                                            Brand:
                                                        </Text>{' '}
                                                        <Badge colorScheme='green'>{data?.brand}</Badge>
                                                    </ListItem>
                                                    <ListItem>
                                                        <Text as={'span'} fontWeight={'bold'}>
                                                            Lowest Price:
                                                        </Text>{' '}
                                                        <Badge colorScheme='green'>€ {data?.lowest_price ? data?.lowest_price : '0.00'}</Badge>
                                                    </ListItem>
                                                    <ListItem>
                                                        <Text as={'span'} fontWeight={'bold'}>
                                                            EAN'S:
                                                        </Text>
                                                        {data?.eans?.map((ean: string) => {
                                                            return (
                                                                <Text fontSize={'small'} color={'teal'}>{ean}</Text>
                                                            );
                                                        })}
                                                    </ListItem>
                                                </List>




                                                <Table variant='simple' spacing={2}>
                                                    <TableCaption placement='top'>
                                                        <Text fontWeight={'bold'} color={'teal'}>
                                                            Sellers
                                                        </Text>
                                                    </TableCaption>
                                                    <Thead>
                                                        <Tr>
                                                            <Th>NAME</Th>
                                                            <Th isNumeric>PRICE</Th>
                                                            <Th>VALID FROM</Th>
                                                        </Tr>
                                                    </Thead>
                                                    <Tbody>
                                                        {data?.sellers?.map((seller: any) => {
                                                            return (
                                                                <Tr fontSize={'small'}>
                                                                    <Td color={'teal'}>{seller?.name}</Td>
                                                                    <Td isNumeric color={'teal'}>€{seller?.price}</Td>
                                                                    <Td color={'teal'}>
                                                                        <Moment format="DD-MM-YYYY HH:mm">
                                                                            {seller?.valid_from}
                                                                        </Moment>
                                                                    </Td>
                                                                </Tr>
                                                            );
                                                        })}
                                                    </Tbody>
                                                </Table>
                                            </Box>}
                                    </Stack>

                                </SimpleGrid>
                            </Container>

                        </Flex>
                    </ModalBody>
                </ModalContent>
            </ModalOverlay>
        </Modal>
    );
};
